import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private _onTitleChangedSubject: Subject<string> = new Subject<string>();
  public onTitleChanged: Observable<string> = this._onTitleChangedSubject.asObservable();


  constructor() { }

  public setCustomTitle(title: string): void {
    this._onTitleChangedSubject.next(title);
  }
}
